<template>
    <v-content>
        <v-container fluid>
            <v-card>
            <v-card-title>Relatórios de Ambulancias</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <AmbulanceReports/>
                </v-card-text>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import AmbulanceReports from "../../../components/admin/general_fleet/AmbulanceReports";
    export default {
        components: {AmbulanceReports},
        data: () => ({
            //
        }),
        computed:{
            //
        },
        watch:{
            //
        },
        methods: {
            //
        }
    };
</script>

<style scoped>
</style>